import { Assert, Branded } from '@cotera/utilities';
import { err, ok, Result } from 'neverthrow';
import * as uuid from 'uuid';

const SEPARATOR = '|';

export type RestateKey = Branded<string, 'restate-key'>;

export type RestateKeyInfo = {
  stackFrameId: string;
  orgId: string;
};

export const derive = ({ stackFrameId, orgId }: RestateKeyInfo): RestateKey =>
  `${orgId}${SEPARATOR}${stackFrameId}` as RestateKey;

export const decode = (key: RestateKey): RestateKeyInfo => {
  const [orgId, stackFrameId, ...rest] = key.split(SEPARATOR);

  Assert.assert(
    orgId !== undefined &&
      stackFrameId !== undefined &&
      rest.length === 0 &&
      uuid.validate(orgId) &&
      uuid.validate(stackFrameId)
  );

  return { stackFrameId, orgId };
};

const validate = (
  input: string
): Result<RestateKey, { t: string; message?: string }> => {
  try {
    const info = decode(input as RestateKey);
    const roundTripKey = derive(info);

    if (input !== roundTripKey) {
      return err({ t: 'stack-frame-key-validation-error' });
    }

    return ok(roundTripKey);
  } catch (e) {
    return err({
      t: 'stack-frame-key-validation-error',
      message: JSON.stringify(e),
    });
  }
};

export const RestateKeyHelpers = {
  derive,
  decode,
  validate,
};
